import { render, staticRenderFns } from "./GTopHeader.vue?vue&type=template&id=2d127560&scoped=true&"
import script from "./GTopHeader.vue?vue&type=script&lang=ts&"
export * from "./GTopHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GTopHeader.vue?vue&type=style&index=0&id=2d127560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d127560",
  null
  
)

export default component.exports